import React from 'react'
import PieChartDisplay from './PieChartDisplay'

const PieChart = ({
  entity,
  chartName,
  chartData,
  locationName
}) => {
 
  return chartData!==null ? (
    <PieChartDisplay
      entity={entity}
      data={chartData}
      chartName={chartName}
      locationName={locationName}
    />
  ) : (
    <div style={{padding:'10px 10px',fontSize:'18px',fontFamily:'Optum Sans',fontWeight:'700'}}>Data Not Available</div>
  )
}

export default PieChart
